import CompaniesViewsList from "./CompaniesViewsList";
import CompaniesListView from "./CompaniesList2";

const CompaniesList = { CompaniesViewsList, CompaniesListView };

export default CompaniesList;
